import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../../entities/shared/paginated-result.entity';
import { AbstractHttpService } from '../../services/abstract-http.service';
import { BarcodeBase } from './entities/barcode-base.entity';
import { BarcodeReference } from './entities/barcode-reference.entity';
import { BarcodeSearchResult } from './entities/barcode-search-result.entity';
import { Barcode } from './entities/barcode.entity';
import { BarcodeQuery, PaginatedBarcodeQuery } from './queries/barcode.query';

@Injectable({
  providedIn: 'root',
})
export class BarcodesApi extends AbstractHttpService {
  endpoint = 'barcodes';

  create(data: BarcodeBase): Observable<Barcode> {
    return this.post<BarcodeBase, Barcode>(data);
  }

  findAll(query: PaginatedBarcodeQuery): Observable<PaginatedResult<Barcode>> {
    return this.get<PaginatedResult<Barcode>>({ query });
  }

  findBarcodeProduct(barcode: string): Observable<BarcodeSearchResult | undefined> {
    return this.get<BarcodeSearchResult | undefined>({ path: `search?barcode=${barcode}` });
  }

  findAllCompact(query?: BarcodeQuery): Observable<BarcodeReference[]> {
    return this.get<BarcodeReference[]>({ path: 'compact', query });
  }

  findOne(id: number): Observable<Barcode> {
    return this.get<Barcode>({ path: id });
  }

  update(id: number, data: BarcodeBase): Observable<Barcode> {
    return this.patch<BarcodeBase, Barcode>(data, { path: id });
  }

  deleteOne(id: number): Observable<Barcode> {
    return this.delete<Barcode>({ path: id });
  }
}
